import React from 'react';
import { Nurse, ROLE_TYPES } from '../../types/nurse';
import AssignNurseDialogCommon from './AssignNurseDialogCommon';

interface AssignNurseDialogProps {
  open: boolean;
  onClose: () => void;
  nurseId: number;
  onSuccess: () => void;
  nurse?: Nurse; // 上席看護師（サポート看護師）情報
}

const AssignNurseDialog: React.FC<AssignNurseDialogProps> = ({
  open,
  onClose,
  nurseId,
  onSuccess,
  nurse
}) => {
  const fixedNurseRoleLabel = (roleType: string) => {
    return ROLE_TYPES[roleType as keyof typeof ROLE_TYPES] || roleType;
  };
  const selectedNurseRoleLabel = (roleType: string) => {
    return ROLE_TYPES[roleType as keyof typeof ROLE_TYPES] || roleType;
  };
  return (
    <AssignNurseDialogCommon
      open={open}
      onClose={onClose}
      nurseId={nurseId}
      onSuccess={onSuccess}
      title="担当看護師の登録"
      mode="assigned"
      fixedNurse={nurse || null}
      fixedNurseTitle="サポート看護師"
      fixedNurseRoleLabel={fixedNurseRoleLabel}
      selectedNurseTitle="担当看護師"
      selectedNurseRoleLabel={selectedNurseRoleLabel}
      searchPlaceholder="名前またはニックネームで検索"
      emptyMessage="条件に一致する看護師が見つかりませんでした"
      buttonText="登録"
    />
  );
};
export default AssignNurseDialog;
